import { Tooltip, LegacyDataTableHeaderColumn, LegacyDataTableRow, LegacyDataTableRowColumn } from "@octopusdeploy/design-system-components";
import type { ProjectResource, ProjectMeanTimeToRecoveryDeployment } from "@octopusdeploy/octopus-server-client";
import { TenantedDeploymentMode } from "@octopusdeploy/octopus-server-client";
import { links } from "@octopusdeploy/portal-routes";
import type { ReactNode } from "react";
import { TrendTable } from "~/areas/insights/components/Reports/TrendTables/TrendTable/TrendTable";
import { formatDurationInWords } from "~/areas/insights/dataTransformation/stringHelpers";
import InternalLink from "~/components/Navigation/InternalLink";
import DateFormatter from "~/utils/DateFormatter";
interface Props {
    title: string;
    note: ReactNode;
    data: ProjectMeanTimeToRecoveryDeployment[];
    project: ProjectResource;
}
export function ProjectTimeToRecoveryTrendTable({ title, note, data, project }: Props) {
    const isTenanted = project.TenantedDeploymentMode != TenantedDeploymentMode.Untenanted;
    return (<TrendTable title={title} isEmpty={data.length === 0} note={note} headerContent={<LegacyDataTableRow>
                    {isTenanted && <LegacyDataTableHeaderColumn>Tenant</LegacyDataTableHeaderColumn>}
                    <LegacyDataTableHeaderColumn>Release</LegacyDataTableHeaderColumn>
                    <LegacyDataTableHeaderColumn>Completed</LegacyDataTableHeaderColumn>
                    <LegacyDataTableHeaderColumn>Deployments until recovery</LegacyDataTableHeaderColumn>
                    <LegacyDataTableHeaderColumn>Recovered from failed release</LegacyDataTableHeaderColumn>
                    <LegacyDataTableHeaderColumn>Time to recovery</LegacyDataTableHeaderColumn>
                </LegacyDataTableRow>} bodyContent={<>
                    {data.map((r) => (<LegacyDataTableRow key={r.Id}>
                            {isTenanted && <LegacyDataTableRowColumn>{r.TenantName}</LegacyDataTableRowColumn>}
                            <LegacyDataTableRowColumn>
                                <InternalLink to={links.releasePage.generateUrl({ spaceId: project.SpaceId, projectSlug: project.Slug, releaseVersion: r.ReleaseVersion })}>{r.ReleaseVersion}</InternalLink>
                            </LegacyDataTableRowColumn>
                            <LegacyDataTableRowColumn>
                                <Tooltip content={DateFormatter.dateToShortFormat(r.CompletedTime) || undefined}>
                                    <InternalLink to={links.deploymentPage.generateUrl({ spaceId: project.SpaceId, projectSlug: project.Slug, releaseVersion: r.ReleaseVersion, deploymentId: r.Id })}>
                                        {DateFormatter.momentAgo(r.CompletedTime)}
                                    </InternalLink>
                                </Tooltip>
                            </LegacyDataTableRowColumn>
                            <LegacyDataTableRowColumn>{r.DeploymentsUntilRecovery}</LegacyDataTableRowColumn>
                            <LegacyDataTableRowColumn>{r.RecoveredFromFailedReleaseVersion}</LegacyDataTableRowColumn>
                            <LegacyDataTableRowColumn>{formatDurationInWords(r.TimeToRecovery)}</LegacyDataTableRowColumn>
                        </LegacyDataTableRow>))}
                </>}/>);
}
